import { useEffect } from 'react'
import { getFirebaseIdToken } from '@/lib/auth-token'

const REQUEST = 'TAPWORK_TOKEN_REQUEST'
const RESPONSE = 'TAPWORK_TOKEN'

/**
 * Lets the Tapwork Chrome extension use this signed-in session instead of carrying a second login.
 *
 * The extension's content script asks over window.postMessage (same window, same origin only) and
 * gets the current Firebase ID token back; it keeps it in session-only extension storage and uses
 * it to ask the normal API which of your emails already have work. Nothing is sent anywhere else,
 * and the API checks the token exactly as it does for this page.
 */
export function ExtensionTokenBridge() {
  useEffect(() => {
    const onMessage = (event: MessageEvent<unknown>) => {
      if (event.source !== window || event.origin !== window.location.origin) return
      const data = event.data as { type?: string } | null
      if (data?.type !== REQUEST) return
      void getFirebaseIdToken(false).then((token) => {
        if (token) window.postMessage({ type: RESPONSE, token }, window.location.origin)
      })
    }
    window.addEventListener('message', onMessage)
    return () => window.removeEventListener('message', onMessage)
  }, [])
  return null
}
